import { Chip } from "@mui/material";
import { AnnounceLevel } from "graphql/API";
import React from "react";
import styles from "./LevelChip.module.scss";

export const LevelChip = React.memo(
  (props: { level: AnnounceLevel | undefined }) => {
    return (
      <Chip
        label={
          props.level === AnnounceLevel.INFO
            ? "お知らせ"
            : props.level === AnnounceLevel.WARN
              ? "注意"
              : props.level === AnnounceLevel.IMPORTANT
                ? "重要"
                : props.level === AnnounceLevel.UPDATE
                  ? "アップデート"
                  : props.level === AnnounceLevel.DM
                    ? "DM"
                    : undefined
        }
        className={
          props.level === AnnounceLevel.INFO
            ? styles.infoChip
            : props.level === AnnounceLevel.WARN
              ? styles.warnChip
              : props.level === AnnounceLevel.IMPORTANT
                ? styles.importantChip
                : props.level === AnnounceLevel.UPDATE
                  ? styles.updateChip
                  : props.level === AnnounceLevel.DM
                    ? styles.dmChip
                    : undefined
        }
      />
    );
  }
);
